/**
 * Strip HTML tags and decode entities (blog list snippets, petition titles/alerts, etc.).
 * Block-level tags (headings, paragraphs, divs, …) are treated as word boundaries so
 * card excerpts don't run together ("Event Description" + "Education…").
 */
const BLOCK_BOUNDARY_TAG =
    'p|div|h[1-6]|li|ul|ol|blockquote|section|article|header|footer|tr|td|th|table|pre';

export function stripHtml(html: string | null | undefined): string {
    if (!html) return '';
    const withBlockBreaks = html
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(new RegExp(`</(${BLOCK_BOUNDARY_TAG})>`, 'gi'), ' ')
        .replace(new RegExp(`<(${BLOCK_BOUNDARY_TAG})[^>]*>`, 'gi'), ' ');
    const doc = new DOMParser().parseFromString(withBlockBreaks, 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}
